import { render, staticRenderFns } from "./RealtimeSummary.vue?vue&type=template&id=078fbd3c&scoped=true"
import script from "./RealtimeSummary.vue?vue&type=script&lang=js"
export * from "./RealtimeSummary.vue?vue&type=script&lang=js"
import style0 from "./RealtimeSummary.vue?vue&type=style&index=0&id=078fbd3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078fbd3c",
  null
  
)

export default component.exports